import i18n from '@/i18n/index.js';
export let rules = {
  required: (tip) => {
    // 必填(tip为提示语)
    return {
      required: true,
      message: tip
    };
  },
  chinese: () => ({
    // 中文、英文、数字
    pattern: /^[\u4E00-\u9FA5A-Za-z\d]+$/,
    message: i18n.t('HT.rules.chinese')
  }),
  chineseNum: (min, max, tip) => {
    // 中文、英文、数字 (tip为提示语)
    const message = i18n.t('HT.rules.chineseNum', {
      min,
      max
    });
    return {
      pattern: new RegExp(`^([\u4E00-\u9FA5A-Za-z0-9]){${min},${max}}$`),
      message: tip || message
    };
  },
  EnglishNum: (min, max, tip) => {
    // 中文、英文、数字 (tip为提示语)
    const message = i18n.t('HT.rules.englishNum', {
      min: min + 1,
      max: max + 1
    });

    return {
      pattern: new RegExp(`^[A-Za-z]([\u4e00-\u9fa5A-Za-z0-9]{${min},${max}})$`),
      message: tip || message
    };
  },
  all: (min, max, tip) => {
    // 任何字符
    const message = i18n.t('HT.rules.all', {
      min,
      max
    });
    return {
      pattern: new RegExp(`^[\\S]{${min},${max}}$`),
      message: tip || message
    };
  },
  number: (min, max, tip) => {
    // 数字 (tip为提示语)
    const message = i18n.t('HT.rules.number', {
      min,
      max
    });
    return {
      pattern: new RegExp(`^([0-9]){${min},${max}}$`),
      message: tip || message
    };
  },
  number1: (min, max, tip) => {
    // 数字 (tip为提示语)
    const message = i18n.t('HT.rules.number1', {
      min,
      max
    });
    return {
      pattern: new RegExp(`^([1-9]{1})([0-9]{${min - 1},${max - 1}})$`),
      message: tip || message
    };
  },

  EnglishNumber: (min, max, tip) => {
    // 中文、英文、数字 (tip为提示语)
    const message = i18n.t('HT.rules.englishNumber', {
      min: min + 1,
      max: max + 1
    });
    return {
      pattern: new RegExp(`^[A-Za-z]([A-Za-z0-9\.]{${min},${max}})$`),
      message: tip || message
    };
  },
  chineseStart: (min, max, tip) => {
    const message = i18n.t('HT.rules.chineseStart', {
      min: min + 1,
      max: max + 1
    });
    return {
      pattern: new RegExp(`^[\u4e00-\u9fa5A-Za-z]([\u4e00-\u9fa5A-Za-z0-9_]{${min},${max}})$`),
      message: tip || message
    };
  },
  englishStart: (min, max, tip) => {
    const message = i18n.t('HT.rules.englishStart', {
      min: min,
      max: max
    });
    return {
      pattern: new RegExp(`^[A-Za-z]([A-Za-z0-9]{${min - 1},${max - 1}})$`),
      message: tip || message
    };
  },
  space: () => {
    return {
      pattern: /^[^\s]*$/,
      message: i18n.t('HT.rules.space')
    };
  },
  twoDecimal: () => ({
    // 两位小数
    pattern: /^\d+(\.\d{0,2})?$/,
    message: i18n.t('HT.rules.twoDecimal')
  }),
  positiveInteger: (tip) => {
    // 包括0整数
    return {
      pattern: /^(\d)+$/,
      message: tip || i18n.t('HT.rules.positiveInteger')
    };
  },
  noZeroInteger: (tip) => {
    // 不包括0正整数
    return {
      pattern: /^[1-9](\d)*$/,
      message: tip || i18n.t('HT.rules.positiveInteger')
    };
  },
  password: () => ({
    // 密码格式
    pattern: /^([a-zA-Z0-9\@\*\.\#]){6,18}$/,
    message: i18n.t('HT.rules.passwordTips'),
    trigger: 'blur'
  }),
  email: () => ({
    // 邮箱格式
    pattern:
      /^[A-Za-z0-9]+([._\\-]*[A-Za-z0-9])*@([A-Za-z0-9]+[-A-Za-z0-9]*[A-Za-z0-9]+.){1,63}[A-Za-z0-9]+$/,
    message: i18n.t('HT.rules.emailTips'),
    trigger: 'blur'
  }),
  phone: () => ({
    pattern:
      /^((0\d{2,3}\d{7,8})|((13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}))$/,
    message: i18n.t('HT.rules.phoneTips'),
    trigger: 'blur'
  }),
  telphone: () => ({
    pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
    message: i18n.t('HT.rules.telphoneTips'),
    trigger: 'blur'
  }),
  card: () => ({
    pattern: /^[\d]{17}[\dXx]$/,
    message: i18n.t('HT.rules.cardTips'),
    trigger: 'blur'
  }),
  paramId: (tip) => {
    return {
      pattern: /^\w+$/,
      message: tip || '必须由数字、字母、下划线组成',
      trigger: 'blur'
    };
  }
};

/**
 * 旧手机校验(中间四位)
 * @param {Object} rule 验证规则
 * @param {String} value 当前验证值
 * @param {Function} callback 回调函数
 */
const validateOldPhone = (vue, key) => {
  return (rule, value, callback) => {
    if (vue.formData[key].includes('*')) {
      return callback(new Error(i18n.t('HT.rules.telphoneTips')));
    }
    return callback();
  };
};

/**
 * 密码校验
 * @param {Object} rule 验证规则
 * @param {String} value 当前验证值
 * @param {Function} callback 回调函数
 */
export const validatePass = (vue) => {
  return (rule, value, callback) => {
    const len = value.length;
    if (len < 6) {
      return callback(new Error(i18n.t('HT.rules.validatePass1')));
    }

    if (len > 18) {
      return callback(new Error(i18n.t('HT.rules.validatePass2')));
    }

    const reg = rules.password().pattern;
    if (!reg.test(value)) {
      return callback(new Error(i18n.t('HT.rules.passwordTips')));
    }

    if (vue.formData.passwdCheck !== '') {
      vue.$refs.form.validateField('passwdCheck'); // 对第二个密码框单独验证
    }

    return callback();
  };
};

/**
 * 密码二次校验
 * @param {Object} rule 验证规则
 * @param {String} value 当前验证值
 * @param {Function} callback 回调函数
 */
export const validatePassCheck = (vue) => {
  return (rule, value, callback) => {
    if (value !== vue.formData.password) {
      return callback(new Error(i18n.t('HT.rules.validatePassCheck')));
    } else {
      callback();
    }
  };
};

/**
 * 不能比max大
 * @param {String} max 查询对象
 */
const validateMax = (max) => {
  return (rule, value, callback) => {
    if (value > max - 0) {
      const message = i18n.t('HT.rules.validateMax', {
        max
      });
      return callback(new Error(message));
    } else {
      callback();
    }
  };
};

/**
 * 不能比min小
 * @param {String} min 查询对象
 */
const validateMin = (min) => {
  return (rule, value, callback) => {
    if (value < min + 0) {
      const message = i18n.t('HT.rules.validateMin', {
        min
      });
      return callback(new Error(message));
    } else {
      callback();
    }
  };
};

/**
 * 验证域名
 * @param {String} tip 错误提示
 * @param {Boolean} flag true: 不需要http:// false: 需要http://
 */
const validateDomain = (tip, flag) => {
  let reg;
  if (flag) {
    reg =
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))?$/; // ip验证
  } else {
    reg =
      /^(http:\/\/|https:\/\/)(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))?$/; // ip验证
  }
  return (rule, value, callback) => {
    let res = value.substring(0, value.indexOf('.'));
    res = res - 0;
    if (typeof res === 'number' && !isNaN(res)) {
      if (!reg.test(value)) {
        return callback(new Error(tip));
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
};

/**
 * @description: 验证ip  多个ip以逗号分隔
 *
 */
const validateIp = (tip, str) => {
  let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))?$/; // ip验证

  return (rule, value, callback) => {
    var valdata = value.split(str || ',');
    for (let i = 0; i < valdata.length; i++) {
      if (!reg.test(valdata[i])) {
        return callback(new Error(tip));
      }
    }
    callback();
  };
};

/**
 * @description: 验证国际化的key  多个ip以逗号分隔
 *
 */
const validateI18nKey = (vue, key) => {
  return (rule, value, callback) => {
    const str = vue.formData[key];

    if (!str) {
      return callback(new Error(i18n.t('HT.rules.addLang.key')));
    }

    if (str.length > 50) {
      return callback(new Error(i18n.t('HT.rules.addLang.key.error1')));
    }

    const reg1 = /^[A-Za-z]$/;
    if (!reg1.test(str[0])) {
      return callback(new Error(i18n.t('HT.rules.addLang.key.error2')));
    }

    const reg2 = /^[A-Za-z0-9_.]+$/;
    if (!reg2.test(str)) {
      return callback(new Error(i18n.t('HT.rules.addLang.key.error3')));
    }
    return callback();
  };
};

export default {
  /**
   * 登录
   */
  login: () => {
    return {
      account: [
        // 名称
        rules.required(i18n.t('HT.rules.login.account')) // 必填
      ],
      password: [
        // 名称
        rules.required(i18n.t('HT.rules.login.password')) // 必填
      ],
      phone: [
        // 名称
        rules.required(i18n.t('HT.rules.login.phone')), // 必填
        rules.telphone() // 手机号码
      ],
      code: [
        // 名称
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ]
    };
  },
  /**
   * 修改手机号码
   */
  editPhone: () => {
    return {
      oldPhone: [
        // 旧手机中间4位
        rules.required(i18n.t('HT.rules.editPhone.oldPhone')), // 必填
        rules.number(4, 4, i18n.t('HT.rules.editPhone.oldPhone')) // 必填
      ],
      phone: [
        // 名称
        rules.required(i18n.t('HT.rules.editPhone.phone')), // 必填
        rules.telphone() // 手机号码
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ]
    };
  },
  /**
   * 修改邮箱
   */
  editEmail: () => {
    return {
      oldEmail: [
        // 补充旧邮箱
        rules.required(i18n.t('HT.rules.editEmail.oldEmail')) // 必填
      ],
      email: [
        // 名称
        rules.required(i18n.t('HT.rules.editEmail.email')), // 必填
        rules.email() // 邮箱
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ]
    };
  },
  /**
   * 修改密码
   */
  editPsw: (vue) => {
    return {
      oldEmail: [
        // 补充旧邮箱
        rules.required(i18n.t('HT.rules.editEmail.oldEmail')) // 必填
      ],
      oldPhone: [
        // 旧手机中间4位
        rules.required(i18n.t('HT.rules.editPhone.oldPhone')), // 必填
        rules.number(4, 4, i18n.t('HT.rules.editPhone.oldPhone')) // 必填
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ],
      password: [
        // 密码
        rules.required(i18n.t('HT.rules.login.password')), // 必填
        {
          validator: validatePass(vue)
        }
      ],
      passwdCheck: [
        // 确认密码
        rules.required(i18n.t('HT.rules.editPsw.passwdCheck')), // 必填
        {
          validator: validatePassCheck(vue)
        }
      ]
    };
  },
  /**
   * AMS
   */

  amsCus: () => {
    return {
      code: [
        // 名称
        rules.required(i18n.t('HT.rules.amsCus.code')) // 必填
      ]
    };
  },
  /**
   * 注册
   * @param {Object} vue vue对象this
   */
  register: (vue) => {
    return {
      username: [
        // 用户列表添加弹窗/注册页面/个人中心 名称
        rules.required(i18n.t('HT.rules.register.username')), // 必填
        rules.chineseNum(5, 30, i18n.t('HT.rules.register.username1'))
        // rules.all(2, 20, '用户名支持2-20个字符')
      ],
      nickname: [
        // 用户昵称
        // rules.chineseNum(2, 20, '姓名支持2-20个字符, 仅限中英文数字')
        rules.all(2, 20, i18n.t('HT.rules.register.nickname'))
      ],
      // 'amsCode': [ // 用户昵称
      //     rules.all(2, 20, '客户代码支持2-20个字符')
      // ],
      changeNickname: [
        //用户列表详情 名称
        rules.required(i18n.t('HT.rules.register.changeNickname')), // 必填
        rules.all(2, 20, i18n.t('HT.rules.register.nickname'))
      ],
      changePhone: [
        //注册页面/用户列表详情 手机
        rules.required(i18n.t('HT.rules.login.phone')), // 必填
        rules.telphone() // 手机号码
      ],
      password: [
        // 密码
        rules.required(i18n.t('HT.rules.login.password')), // 必填
        {
          validator: validatePass(vue)
        }
      ],
      passwdCheck: [
        // 确认密码
        rules.required(i18n.t('HT.rules.editPsw.passwdCheck')), // 必填
        {
          validator: validatePassCheck(vue)
        }
      ],
      phone: [
        // 用户列表添加弹窗 手机
        rules.telphone() // 手机号码
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')), // 必填
        rules.number(4, 4, i18n.t('HT.rules.register.code'))
      ],
      type: [
        rules.required(i18n.t('HT.rules.register.type')) // 必填
      ],
      group_ids: [
        rules.required(i18n.t('HT.rules.register.groupIds')) // 必填
      ],
      parent_id: [
        // 三级用户所属的二级账号
        rules.required(i18n.t('HT.rules.register.parentAccount')) // 必填
      ],
      email: [
        // 邮箱
        rules.email() // 邮箱
      ],
      oldPassword: [
        rules.password(),
        rules.required(i18n.t('HT.rules.register.oldPassword')) // 必填
      ]
    };
  },

  /**
   * 修改邮箱
   */
  bindemail: () => {
    return {
      email: [
        // 邮箱
        rules.required(i18n.t('HT.rules.bindemail.email')), // 必填
        rules.email() // 邮箱
      ]
    };
  },

  /**
   * 新增分组规则
   */
  addGroup: () => {
    return {
      name: [
        // 名称
        rules.required(i18n.t('HT.rules.addGroup.name')), // 必填
        rules.chineseStart(3, 49)
      ]
    };
  },
  /**
   * 新增分组规则
   */
  addUserGroup: () => {
    return {
      group_name: [
        // 名称
        rules.required(i18n.t('HT.rules.addUserGroup.groupName')), // 必填
        rules.chineseStart(1, 9)
      ]
    };
  },
  /**
   * API分组详情编辑规则
   */
  groupDetail: () => {
    return {
      name: [
        // 名称
        rules.required(i18n.t('HT.rules.groupDetail.name')), // 必填
        rules.chineseStart(3, 49)
      ]
    };
  },
  /**
   * 新增额度充值规则
   */
  topUp: () => {
    return {
      name: [
        // 名称
        rules.required(i18n.t('HT.rules.topUp.name')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.topUp.noZeroInteger'))
      ]
    };
  },
  /**
   * 新增密匙规则
   */
  Key: () => {
    return {
      password: [
        // 名称
        rules.required(i18n.t('HT.rules.key.password')) // 必填
      ],
      certificate: [
        // 名称
        rules.required(i18n.t('HT.rules.key.certificate')) // 必填
      ]
    };
  },
  /**
   * 新增API规则
   */
  addApi: () => {
    return {
      group_id: [
        rules.required(i18n.t('HT.rules.addApi.groupId')) // 必填
      ],
      name: [
        // 名称
        rules.required(i18n.t('HT.rules.addApi.name')) // 必填
        // rules.chineseStart(3, 99),
      ],
      'safety_certification.type': [
        //安全认证
        rules.required(i18n.t('HT.rules.addApi.type')) // 必填
      ],
      'safety_certification.client_id': [
        rules.required(i18n.t('HT.rules.addApi.clientId')) // 必填
      ],
      'safety_certification.api_type': [
        rules.required(i18n.t('HT.rules.addApi.apiType')) // 必填
      ],
      'safety_certification.client_secret': [
        rules.required(i18n.t('HT.rules.addApi.clientDecret')) // 必填
      ],
      'safety_certification.token_name': [
        rules.required(i18n.t('HT.rules.addApi.tokenName')) // 必填
      ],
      'safety_certification.app_auth_type': [
        rules.required(i18n.t('HT.rules.addApi.appAuthType')) // 必填
      ],
      'safety_certification.app_auth_param_name': [
        rules.required(i18n.t('HT.rules.addApi.appAuthParamName')) // 必填
      ],
      'safety_certification.sign_auth': [
        rules.required(i18n.t('HT.rules.addApi.type')) // 必填
      ],
      protocol: [
        rules.required(i18n.t('HT.rules.addApi.protocol')) // 必填
      ],
      uri: [
        rules.required(i18n.t('HT.rules.addApi.uri')), // 必填
        {
          pattern: /^\/.*/,
          message: i18n.t('HT.rules.addApi.uri1')
        }
      ],
      method: [
        rules.required(i18n.t('HT.rules.addApi.method')) // 必填
      ],
      transfer_type: [
        rules.required(i18n.t('HT.rules.addApi.transferType')) // 必填
      ],
      body_type: [
        rules.required(i18n.t('HT.rules.addApi.bodyType')) // 必填
      ],
      type: [
        rules.required(i18n.t('HT.rules.addApi.type1')) // 必填
      ],
      url: [
        rules.required(i18n.t('HT.rules.addApi.url')), // 必填
        {
          pattern:
            /^(http:\/\/|https:\/\/)(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))?$/,
          message: i18n.t('HT.rules.addApi.url1')
        },
        {
          validator: validateDomain(i18n.t('HT.rules.addApi.url1')) // 验证是否是ip
        }
      ],
      path: [
        rules.required(i18n.t('HT.rules.addApi.path')), // 必填
        {
          pattern: /^\/.*/,
          message: i18n.t('HT.rules.addApi.path1')
        }
      ],
      timeout: [
        rules.required(i18n.t('HT.rules.addApi.timeout')), // 必填
        rules.positiveInteger(i18n.t('HT.rules.positiveInteger.placeholder')) // 正整数
      ],
      mock_http_status: [
        // mock响应Http状态码
        rules.positiveInteger(i18n.t('HT.rules.positiveInteger.placeholder')) // 正整数
      ],
      content_type: [
        rules.required(i18n.t('HT.rules.addApi.contentType')) // 必填
      ]
    };
  },

  /**
   * 参数验证
   */
  params: () => {
    return {
      name: [
        // 参数名
        rules.required('') // 必填
      ],
      position: [
        // 参数位置
        rules.required('') // 必填
      ],
      type: [
        // 类型
        rules.required('') // 必填
      ],
      mapping_name: [
        // 参数名
        rules.required('') // 必填
      ],
      mapping_position: [
        // 参数位置
        rules.required('') // 必填
      ]
    };
  },

  /**
   * 发布API
   */
  release: () => {
    return {
      env: [
        // 环境
        rules.required(i18n.t('HT.rules.release.env')) // 必填
      ],
      remark: [
        // 描述
        rules.required(i18n.t('HT.rules.release.remark')) // 必填
      ]
    };
  },
  /**
   * 新增应用规则
   */
  addApply: () => {
    return {
      name: [
        // 名称
        rules.required(i18n.t('HT.rules.addApply.name')), // 必填
        rules.chineseNum(6, 30)
      ]
    };
  },
  /**
   * 新增产品规则
   */
  addProduct: () => {
    return {
      name: [
        // 名称
        rules.required(i18n.t('HT.rules.addProduct.name')), // 必填
        rules.chineseNum(6, 30)
      ],
      type: [
        rules.required(i18n.t('HT.rules.addProduct.type'))
      ],
      remark: [
        // 备注
        rules.required(i18n.t('HT.rules.addProduct.remark')) // 必填
      ]
    };
  },

  /**
   * 绑定应用
   */
  bindApply: (max) => {
    return {
      app_id: [
        // 应用id
        rules.required(i18n.t('HT.rules.bindApply.appId')) // 必填
      ],
      ip_address: [
        // ip列表
        rules.required(i18n.t('HT.rules.bindApply.ipAddress')) // 必填
      ],
      rate: [
        // 流量限制
        rules.required(i18n.t('HT.rules.bindApply.rate')), // 必填
        rules.positiveInteger(i18n.t('HT.rules.positiveInteger.placeholder')), // 正整数
        {
          validator: validateMax(max) // 小于max
        }
      ]
    };
  },
  /**
   * 绑定产品
   */
  bindProduct: () => {
    return {
      product_id: [
        // 产品id
        rules.required(i18n.t('HT.rules.bindProduct.productId')) // 必填
      ]
    };
  },
  /**
   * 绑定api
   */
  bindApi: () => {
    return {
      apiId: [
        // api id
        rules.required(i18n.t('HT.rules.bindApi.apiId')) // 必填
      ],
      date: [
        // 时间
        rules.required(i18n.t('HT.rules.bindApi.date')) // 必填
      ],
      flag: [
        // 审批
        rules.required(i18n.t('HT.rules.bindApi.flag')) // 必填
      ]
    };
  },

  /**
   * 绑定域名
   */
  bindDomain: () => {
    return {
      domain: [
        // 域名
        rules.required(i18n.t('HT.rules.bindDomain.domain')), // 必填
        {
          pattern:
            /^(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))?$/,
          message: i18n.t('HT.rules.bindDomain.domain.message')
        },
        {
          validator: validateDomain(i18n.t('HT.rules.bindDomain.domain.message'), true) // 验证是否是ip
        }
      ],
      envs: [
        // 环境
        rules.required(i18n.t('HT.rules.release.env')) // 必填
      ]
    };
  },

  /**
   * 添加流量控制
   */
  addFlow: (min) => {
    return {
      name: [
        rules.required(i18n.t('HT.rules.addFlow.name')), // 必填
        rules.chineseStart(3, 49)
      ],
      rate: [
        // 流量限制
        rules.required(i18n.t('HT.rules.bindApply.rate')), // 必填
        rules.positiveInteger(i18n.t('HT.rules.positiveInteger.placeholder')), // 正整数
        {
          validator: validateMin(min) // 大于min
        }
      ],
      unit: [
        // 时间单位
        rules.required(i18n.t('HT.rules.addFlow.unit')) // 必填
      ]
    };
  },

  /**
   * 绑定域名
   */
  addAccess: () => {
    return {
      name: [
        // 流量限制
        rules.required(i18n.t('HT.rules.addAccess.name')), // 必填
        rules.chineseStart(3, 49)
      ],
      type: [
        // 时间单位
        rules.required(i18n.t('HT.rules.addAccess.type')) // 必填
      ],
      ip_address: [
        //ip列表
        rules.required(i18n.t('HT.rules.bindApply.ipAddress')), //必填
        {
          validator: validateIp(i18n.t('HT.rules.addAccess.ipAddress')) // 验证是否是ip
        }
      ]
    };
  },
  /**
   * 添加ip
   */
  AccessIp: () => {
    return {
      app_id: [
        // 应用ID
        rules.positiveInteger('')
      ],
      addr: [
        //ip列表
        rules.required(i18n.t('HT.rules.bindApply.ipAddress')), //必填
        {
          validator: validateIp(i18n.t('HT.rules.addAccess.ipAddress'), ';') // 验证是否是ip
        }
      ]
    };
  },

  /**
   * API调试
   */
  testApi: () => {
    return {
      apiGroup: [
        // api分组
        rules.required(i18n.t('HT.rules.testApi.apiGroup')) // 必填
      ],
      apiId: [
        // api
        rules.required(i18n.t('HT.rules.bindApi.apiId')) // 必填
      ],
      env: [
        // 环境
        rules.required(i18n.t('HT.rules.release.env')) // 必填
      ],
      domain: [
        // 域名
        rules.required(i18n.t('HT.rules.testApi.domain')) // 必填
      ],
      'safety.type': [
        // 认证
        rules.required(i18n.t('HT.rules.testApi.safetyType')) // 必填
      ],

      Path: [
        // path
        rules.required(i18n.t('HT.rules.testApi.path')) // 必填
      ],
      Header: [
        // header
        rules.required(i18n.t('HT.rules.testApi.header')) // 必填
      ],
      Query: [
        // query
        rules.required(i18n.t('HT.rules.testApi.query')) // 必填
      ],
      'safety.AppCode': [
        // AppCode
        rules.required(i18n.t('HT.rules.testApi.appCode')) // 必填
      ],
      'safety.AppKey': [
        // AppKey
        rules.required(i18n.t('HT.rules.testApi.appKey')) // 必填
      ],
      'safety.AppSecret': [
        // AppSecret
        rules.required(i18n.t('HT.rules.testApi.appSecret')) // 必填
      ]
    };
  },

  /**
   * API调试 客户子账号
   */
  testApi2: () => {
    return {
      env: [
        // env
        rules.required(i18n.t('HT.rules.release.env')) // 必填
      ],
      domain: [
        // domain
        rules.required(i18n.t('HT.rules.testApi.domain')) // 必填
      ],
      'safety.type': [
        // 选择类型
        rules.required(i18n.t('HT.rules.testApi.safetyType')) // 必填
      ],
      'safety.APPList': [
        // 选择应用
        rules.required(i18n.t('HT.rules.bindApply.appId')) // 必填
      ],
      Path: [
        // Path
        rules.required(i18n.t('HT.rules.testApi.path')) // 必填
      ],
      Header: [
        // Header
        rules.required(i18n.t('HT.rules.testApi.header')) // 必填
      ],
      Query: [
        // Query
        rules.required(i18n.t('HT.rules.testApi.query')) // 必填
      ],
      'safety.AppCode': [
        // AppCode
        rules.required(i18n.t('HT.rules.testApi.appCode')) // 必填
      ],
      'safety.AppKey': [
        // AppKey
        rules.required(i18n.t('HT.rules.testApi.appKey')) // 必填
      ],
      'safety.AppSecret': [
        // AppSecret
        rules.required(i18n.t('HT.rules.testApi.appSecret')) // 必填
      ]
    };
  },
  /**
   * 结果码
   */
  addCode: () => {
    return {
      code: [
        rules.required(i18n.t('HT.rules.addCode.code')) // 必填
      ],
      http_status: [
        rules.required(i18n.t('HT.rules.addCode.httpStatus')) // 必填
      ]
    };
  },

  /**
   * 设备接入管理
   */
  addDevice: () => {
    return {
      type: [
        rules.required(i18n.t('HT.rules.addDevice.type')) // 必填
      ],
      manufacturer: [
        rules.required(i18n.t('HT.rules.addDevice.manufacturer')) // 必填
      ],
      protocol: [
        rules.required(i18n.t('HT.rules.addDevice.protocol')) // 必填
      ],
      domains: [
        // 域名
        rules.required(i18n.t('HT.rules.bindDomain.domain.message')), // 必填
        {
          pattern:
            /^(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})?(\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))?$/,
          message: i18n.t('HT.rules.bindDomain.domain.message')
        },
        {
          validator: validateDomain(i18n.t('HT.rules.bindDomain.domain.message'), true) // 验证是否是ip
        }
      ]
    };
  },

  /**
   * swagger输入
   */
  swagger: () => {
    return {
      groupId: [
        rules.required(i18n.t('HT.pleaseSelect')) // 必填
      ],
      remark: [
        rules.required(i18n.t('HT.pleaseInput')) // 必填
      ]
    };
  },

  /**
   * 申请License
   */
  addLicense: () => {
    return {
      title: [
        rules.required(i18n.t('HT.rules.addLicense.title')), // 必填
        rules.all(4, 64) //长度
      ],
      phone: [
        rules.required(i18n.t('HT.rules.addLicense.phone')), // 必填
        rules.phone() // 联系方式
      ],
      sales: [
        rules.all(2, 32) //长度
      ],
      engineer: [
        rules.all(2, 32) //长度
      ],
      max_conn: [
        rules.required(i18n.t('HT.rules.addLicense.maxConn')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.addLicense.maxConn1')), // 正整数
        {
          validator: validateMax(500000) // 小于max
        }
      ],
      max_hosts: [
        rules.required(i18n.t('HT.rules.addLicense.maxHosts')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.addLicense.maxConn1')), // 正整数
        {
          validator: validateMax(100) // 小于max
        }
      ],
      expire_date: [
        rules.required(i18n.t('HT.rules.addLicense.expireDate')) // 必填
      ]
    };
  },

  /**
   * License审批
   */
  approval: () => {
    return {
      status: [
        rules.required(i18n.t('HT.rules.approval.status')) // 必填
      ],
      message: [
        rules.required(i18n.t('HT.rules.approval.message')), // 必填
        rules.all(2, 32) //长度
      ],
      max_conn: [
        rules.required(i18n.t('HT.rules.addLicense.maxConn')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.addLicense.maxConn1')), // 正整数
        {
          validator: validateMax(500000) // 小于max
        }
      ],
      max_hosts: [
        rules.required(i18n.t('HT.rules.addLicense.maxHosts')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.addLicense.maxConn1')), // 正整数
        {
          validator: validateMax(100) // 小于max
        }
      ]
    };
  },

  /**
   * License修改
   */
  modify: () => {
    return {
      title: [
        rules.required(i18n.t('HT.rules.addLicense.title')), // 必填
        rules.all(4, 64) //长度
      ],
      phone: [
        rules.required(i18n.t('HT.rules.addLicense.phone')), // 必填
        rules.phone() // 手机号码
      ],
      sales: [
        rules.all(2, 32) //长度
      ],
      engineer: [
        rules.all(2, 32) //长度
      ],
      max_conn: [
        rules.required(i18n.t('HT.rules.addLicense.maxConn')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.addLicense.maxConn1')), // 正整数
        {
          validator: validateMax(500000) // 小于max
        }
      ],
      max_hosts: [
        rules.required(i18n.t('HT.rules.addLicense.maxHosts')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.addLicense.maxConn1')), // 正整数
        {
          validator: validateMax(100) // 小于max
        }
      ],
      expire_date: [
        rules.required(i18n.t('HT.rules.addLicense.expireDate')) // 必填
      ]
    };
  },

  /**
   * License续期
   */
  renewal: () => {
    return {
      add_date: [
        rules.required(i18n.t('HT.rules.addLicense.expireDate')) // 必填
      ]
    };
  },

  /**
   * 推送配置
   */
  addPush: () => {
    return {
      type: [
        rules.required(i18n.t('HT.pleaseSelect')) // 必填
      ],
      url: [
        rules.required(i18n.t('HT.rules.addPush.url')) // 必填
      ],
      expression: [
        rules.required(i18n.t('HT.rules.addPush.expression')) // 必填
      ]
    };
  },

  /**
   * 个人中心，修改手机号
   */
  modifyPhone: () => {
    return {
      phone: [
        // 用户列表添加弹窗 手机
        rules.required(i18n.t('HT.rules.login.phone')), // 必填
        rules.telphone() // 手机号码
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')), // 必填
        rules.number(4, 4, i18n.t('HT.rules.register.code'))
      ]
    };
  },
  // 通道管理
  addSms: () => {
    return {
      name: [
        rules.required(i18n.t('HT.rules.addSms.name')), // 必填
        rules.all(2, 10) //长度
      ],
      status: [
        rules.required(i18n.t('HT.rules.addSms.status')) // 必填
      ]
    };
  },

  /**
   * 通道模板
   */
  channel: () => {
    return {
      name: [
        //通道名称
        rules.required(i18n.t('HT.rules.channel.name')),
        rules.all(2, 20) //长度
      ],
      code: [
        // 编码
        rules.required(i18n.t('HT.rules.channel.code')),
        rules.EnglishNum(4, 49) //长度
      ],
      type: [
        // 类型
        rules.required(i18n.t('HT.rules.channel.type'))
      ],
      priority: [
        //优先级
        rules.required(i18n.t('HT.rules.channel.priority')),
        rules.number1(1, 4) //长度
      ]
    };
  },
  // 语音模板
  template: () => {
    return {
      name: [
        //模板名
        rules.required(i18n.t('HT.rules.template.name')),
        rules.all(2, 30)
      ],
      code: [rules.required(i18n.t('HT.rules.template.code')), rules.EnglishNumber(4, 49)],
      content: [rules.required(i18n.t('HT.rules.template.content'))],
      sign_id: [rules.required(i18n.t('HT.rules.template.signId'))],
      type: [rules.required(i18n.t('HT.rules.template.type'))],
      status: [rules.required(i18n.t('HT.rules.addSms.status'))],
      channels: [rules.required(i18n.t('HT.rules.template.channels'))]
    };
  },
  // 通用发送限制管理
  currency: () => {
    return {
      minute: [
        //每分钟限制
        rules.required(i18n.t('HT.rules.currency.minute')),
        rules.noZeroInteger('1~9999') //长度
      ],
      day: [
        //每天限制
        rules.required(i18n.t('HT.rules.currency.day')),
        rules.noZeroInteger('1~9999') //长度
      ],
      vip_minute: [
        //每分钟限制
        rules.required(i18n.t('HT.rules.currency.minute')),
        rules.noZeroInteger('1~9999') //长度
      ],
      vip_day: [
        //每天限制
        rules.required(i18n.t('HT.rules.currency.day')),
        rules.noZeroInteger('1~9999') //长度
      ]
    };
  },

  // 限制模块
  addLimit: () => {
    return {
      app_id: [
        //每天限制
        rules.required(i18n.t('HT.rules.addLimit.appId')),
        rules.number(1, 10) //长度
      ],
      minute: [
        //每分钟限制
        rules.required(i18n.t('HT.rules.currency.minute')),
        rules.noZeroInteger('1~9999')
      ],
      day: [
        //每天限制
        rules.required(i18n.t('HT.rules.currency.day')),
        rules.noZeroInteger('1~9999')
      ],
      type: [
        // 类型
        rules.required(i18n.t('HT.rules.addLimit.type'))
      ]
    };
  },

  // 删除漂移点
  delPoint: () => {
    return {
      reason: [
        // 删除原因
        rules.required(i18n.t('HT.rules.delPoint.reason'))
      ]
    };
  },

  // 修改手机
  changePhone: (vue) => {
    return {
      oldPhone: [
        {
          validator: validateOldPhone(vue, 'oldPhone') // 不能为空
        }
      ],
      phone: [
        // 新手机
        rules.required(i18n.t('HT.rules.login.phone')), // 必填
        rules.telphone() // 手机号码
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ]
    };
  },

  // 修改邮箱
  changeEmail: () => {
    return {
      oldEmail: [
        // 删除原因
        rules.required(i18n.t('HT.rules.changeEmail.oldEmail')) // 必填
      ],
      email: [
        // 名称
        rules.required(i18n.t('HT.rules.emailTips')), // 必填
        rules.email() // 邮箱
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ]
    };
  },

  // 修改密码
  changePassword: (vue) => {
    return {
      phone: [
        // 删除原因
        {
          validator: validateOldPhone(vue, 'phone') // 不能为空
        }
      ],
      email: [
        // 名称
        rules.required(i18n.t('HT.rules.emailTips')), // 必填
        rules.email() // 邮箱
      ],
      code: [
        // 验证码
        rules.required(i18n.t('HT.rules.login.code')) // 必填
      ],
      password: [
        // 密码
        rules.required(i18n.t('HT.rules.login.password')), // 必填
        {
          validator: validatePass(vue)
        }
      ],
      passwdCheck: [
        // 确认密码
        rules.required(i18n.t('HT.rules.editPsw.passwdCheck')), // 必填
        {
          validator: validatePassCheck(vue)
        }
      ]
    };
  },

  // 添加规格
  addProductInfo: () => {
    return {
      type: [
        // 删除原因
        rules.required(i18n.t('HT.rules.addProductInfo.type')) // 必填
      ],
      count: [
        // 名称
        rules.required(i18n.t('HT.rules.addProductInfo.count')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.positiveInteger.placeholder'))
      ],
      money: [
        // 验证码
        rules.required(i18n.t('HT.rules.addProductInfo.money')), // 必填
        rules.noZeroInteger(i18n.t('HT.rules.positiveInteger.placeholder'))
      ]
    };
  },

  // 修改用户名
  changeUsername: () => {
    return {
      username: [
        // 用户列表添加弹窗/注册页面/个人中心 名称
        rules.required(i18n.t('HT.rules.register.username')), // 必填
        rules.englishStart(5, 30, i18n.t('HT.rules.changeUsername.username'))
      ]
    };
  },

  // 添加订单
  addOrder: () => {
    return {
      type: [
        // 分类
        rules.required(i18n.t('HT.rules.addOrder.type')) // 必填
      ],
      desc: [
        // 工单描述
        rules.required(i18n.t('HT.rules.addOrder.desc')) // 必填
      ]
    };
  },

  // 国际化
  addLang: (vue) => {
    return {
      key: [
        // Key
        rules.required(i18n.t('HT.rules.addLang.key')), // 必填
        {
          validator: validateI18nKey(vue, 'key')
        }
      ],
      key_type: [
        // 类型
        rules.required(i18n.t('HT.rules.addLang.keyType')) // 必填
      ],
      key_scene: [
        // 场景
        rules.required(i18n.t('HT.rules.addLang.keyScene')) // 必填
      ],
      zh_value: [
        // 原文文本
        rules.required(i18n.t('HT.rules.addLang.zhValue')) // 必填
      ],
      en_value: [
        // 翻译文本
        rules.required(i18n.t('HT.rules.addLang.enValue')) // 必填
      ]
    };
  },
  // 新增用户组
  addFaceUserGroup: () => {
    return {
      group_id: [
        rules.required(i18n.t('HT.rules.register.groupId')), // 必填
        rules.paramId(i18n.t('HT.rule.groupParamId'))
      ]
    };
  },
  // 新增用户
  addFaceUser: () => {
    return {
      user_id: [
        rules.required(i18n.t('HT.rules.enter.ueserId')), // 必填
        rules.paramId(i18n.t('HT.rule.userParamId'))
      ],
      imagelist: [
        rules.required(i18n.t('HT.uploadImage.message', {num: 1})), // 必填
      ]
    };
  },
  // 新增产品类型
  addProductType: () => {
    return {
      name: [
        rules.required(i18n.t('HT.ProductType.rules')),
        rules.chineseNum(1,32)
      ]
    };
  }
};
